/* tslint:disable: ordered-imports*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppCommonModule } from '@common/app-common.module';
import { IconsModule } from '@modules/icons/icons.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import * as onboardingComponents from './components';

/**
 * Módulo del dominio Onboarding. Agrupa toda la UI del onboarding (banner del dashboard, tarjetas,
 * anillo de progreso, modal de celebración, overlay/blackout de tours, progreso del navbar y
 * modales de detalle/completado de fase).
 *
 * Los servicios (`OnboardingService`, `TourOrchestratorService`, `OnboardingModalService`) son
 * `providedIn: 'root'`, por lo que NO se declaran en `providers` (siguen siendo singletons inyectables
 * desde cualquier módulo).
 *
 * Importa `AppCommonModule` para reutilizar UI compartida, e `IconsModule` (fa-icon) + `NgbModule`
 * (modales) que necesitan los componentes. `AppCommonModule` NO importa este módulo → grafo acíclico.
 */
@NgModule({
    imports: [CommonModule, RouterModule, AppCommonModule, IconsModule, NgbModule],
    declarations: [...onboardingComponents.components],
    exports: [...onboardingComponents.components],
})
export class OnboardingModule {}
